import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const mealVouchersRoutesDictionary = moduleRouteDictionaryFactory(
  'mealVouchers',
  'mealVouchers',
  {
    movements: 'movements',
    cardOrders: 'card-orders',
    cardOrdersDetail: 'card-orders/detail/:orderId',
    bankTransfers: 'bank-transfers',
    bankTransfersAssociateOrders: 'bank-transfers/associate-orders',
  },
);
